export default __webpack_public_path__ + "static/media/chennai.4e24542e.png";